/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExclusionTermCreatedByUser } from './ExclusionTermCreatedByUser';
import {
    ExclusionTermCreatedByUserFromJSON,
    ExclusionTermCreatedByUserFromJSONTyped,
    ExclusionTermCreatedByUserToJSON,
    ExclusionTermCreatedByUserToJSONTyped,
} from './ExclusionTermCreatedByUser';

/**
 * 
 * @export
 * @interface ExclusionTerm
 */
export interface ExclusionTerm {
    /**
     * Unique identifier for the exclusion term
     */
    id: string;
    /**
     * Facility ID this term belongs to
     */
    facility_id: string;
    /**
     * The exclusion term text
     */
    term: string;
    /**
     * ID of the user who created this term
     */
    created_by_user_id: string;
    /**
     * Timestamp when the term was created
     */
    createdAt: string;
    /**
     * Timestamp when the term was last modified
     */
    updatedAt: string;
    /**
     * Timestamp when the term was deleted
     */
    deletedAt?: string;
    /**
     * 
     */
    created_by_user: ExclusionTermCreatedByUser;
}

/**
 * Check if a given object implements the ExclusionTerm interface.
 */
export function instanceOfExclusionTerm(value: object): value is ExclusionTerm {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('term' in value) || value['term'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('created_by_user' in value) || value['created_by_user'] === undefined) return false;
    return true;
}

export function ExclusionTermFromJSON(json: any): ExclusionTerm {
    return ExclusionTermFromJSONTyped(json, false);
}

export function ExclusionTermFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExclusionTerm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'term': json['term'],
        'created_by_user_id': json['created_by_user_id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
        'created_by_user': ExclusionTermCreatedByUserFromJSON(json['created_by_user']),
    };
}

export function ExclusionTermToJSON(json: any): ExclusionTerm {
    return ExclusionTermToJSONTyped(json, false);
}

export function ExclusionTermToJSONTyped(value?: ExclusionTerm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'term': value['term'],
        'created_by_user_id': value['created_by_user_id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'deletedAt': value['deletedAt'],
        'created_by_user': ExclusionTermCreatedByUserToJSON(value['created_by_user']),
    };
}

